import React, { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import DealCreateCreditAppeal from './DealCreate/DealCreateCreditAppeal';
import updateCreditAppeal from '../../api/creditPlatform/updateCreditAppeal';
import alert from '../../helpers/alert';

const UpdateCreditAppeal = ({ appeal, orders, deal, documents, update }) => {
  const [showModal, setShowModal] = useState(false);
  const [sendFormLoading, setSendFormLoading] = useState(false);

  const defaultValues = useMemo(() => {
    try {
      return JSON.parse(appeal?.json);
    } catch (e) {
      return {};
    }
  }, [appeal]);

  const handleSubmit = (payload, _documents, files) => {
    setSendFormLoading(true);

    return updateCreditAppeal(
      {
        ...payload,
        bussinessKey: appeal?.bankOwnerId,
        bankId: appeal?.id,
        MaritalStatus: payload?.MaritalStatus?.value,
      },
      files
    )
      // { sent } ÑÐ¸ÑÐ°ÐµÑ Ð°Ð½ÐºÐµÑÐ° â Ð¿Ð¾ Ð½ÐµÐ¼Ñ Ð¾Ð½Ð° ÑÐµÑÐ°ÐµÑ, Ð¼Ð¾Ð¶Ð½Ð¾ Ð»Ð¸ ÑÑÐ¸ÑÐ°ÑÑ ÑÐµÑÐ½Ð¾Ð²Ð¸Ðº.
      .then(() => {
        alert.success('ÐÐ°Ð½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ñ');
        setShowModal(false);
        update();
        return { sent: true };
      })
      .catch((err) => {
        alert.error(err?.response?.data || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¸ Ð·Ð°ÑÐ²ÐºÐ¸');
        return { sent: false };
      })
      .finally(() => setSendFormLoading(false));
  };

  return (
    <>
      <Button fill text="ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ" onClick={() => setShowModal(true)} />
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        width="100%"
        contentStyle={{ maxWidth: 800 }}
      >
        <DealCreateCreditAppeal
          onSubmit={handleSubmit}
          deal={deal}
          orders={orders}
          agreementModal={false}
          setAgreementModal={() => {}}
          sendFormLoading={sendFormLoading}
          creditAppeals={[]}
          defaultValues={defaultValues}
          udvIsRequired={false}
        />
      </Modal>
    </>
  );
};

export default UpdateCreditAppeal;
